import React from "react";
import "./standingLegend.scss";

const Badge: React.FC<{ state: string; label: string }> = ({ state, label }) => (
  <span className={`standing-badge standing-badge--${state}`}>{label}</span>
);

/** Explains the calendar badges (prototype screen B). Rendered only for enabled schools. */
const StandingLegend: React.FC = () => (
  <div className="standing-legend">
    <span>
      <Badge state="standing" label="Standing order" /> filled in from the
      standing order
    </span>
    <span>
      <Badge state="changed" label="Lunch: Changed" /> you changed it by hand
    </span>
    <span>
      <Badge state="skipped" label="Skipped" /> no order that day
    </span>
    <span>
      <Badge state="needs-you" label="Lunch: Needs you" /> no suitable dish:
      please choose
    </span>
    <span>
      <Badge state="closed" label="Closed" /> closed: the order deadline has
      passed
    </span>
  </div>
);

export default StandingLegend;
